import SignPopup from '../../features/SignPopup/SignPopup'
import Hospital from 'assets/svg/HospitalWithouBG.svg'
import './style.scss'
import Typography from '../../components/Typography/Typography'
import { TYPOGRAPHY_WEIGHT } from '../../components/Typography'
import useRouter from '../../hooks/useRouter'
import { routes } from '../../router'
import { useDescope } from '@descope/react-sdk'
import { LogOutAction } from '../../redux/store/user/slice'
import { useAppDispatch } from '../../redux/createStore'

const UserNotExist = () => {
  const { push } = useRouter()
  const { logout } = useDescope()
  const dispatch = useAppDispatch()
  return (
    <SignPopup
      isBack
      onBackPress={() => {
        logout().then(() => {
          dispatch(LogOutAction())
          push(routes.login)
        })
      }}
      newLogo={Hospital}
      className="not-exist-container"
    >
      <Typography.HeadlineD4 className="mt-32" weight={TYPOGRAPHY_WEIGHT.BOLD}>
        User doesn't have permissions to view the system
      </Typography.HeadlineD4>
      <Typography.Body1 className="mt-12">
        This email address is not associated with an active account.
      </Typography.Body1>
    </SignPopup>
  )
}

export default UserNotExist
